import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "./authSlice";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_FETCH_URL,
  credentials: 'include',
});

// Oturum süresi dolduğunda (401) listeler sessizce boş kalmasın:
// kullanıcıyı çıkış yaptırıp giriş ekranına yönlendir.
export const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  const url = typeof args === 'string' ? args : args?.url;
  if (result.error?.status === 401 && !url?.endsWith('/users/auth')) {
    api.dispatch(logout());
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ['User', 'UserAssignedItems'],
  endpoints: (builder) => ({})
});
